<template>
  <div id="print-step">
    <print ref="print">
      <page>
        <div class="nation">{{ $t('NATION') }}</div>
        <div class="motto">{{ $t('MOTTO') }}</div>
        <br/>
        <div class="hr"/>
        <div class="header">
          <div class="logo-holder">
            <logo-inversed-circle class="icon"/>
            <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
          </div>
          <div class="title-info">
            <span class="bill">{{ $t('MORTGAGE_CONTRACT') }}</span>
            <br/><br/>
            <strong class="info">{{ $t('CONTRACT_ID') }} ({{ $t('CNTRCT') }}): {{ branch }}-{{ newContractMifosId }}</strong><br/>
            <strong class="info">{{ $t('CLIENT_ID') }} (KH): HCMKH-{{ client.mifosId }}</strong><br/>
          </div>
        </div>
        <br/>
        <br/>
        <br/>
        <span>{{ $t('DATE') }} {{ moment(contract.maturesDate, DISPLAY_DATE_FORMAT).format('DD-M-YYYY') }}, {{ $t('BEGIN_PARAM') }}:</span>
        <br/>
        <br/>
        <b-row>
          <b-col cols="6">
            <span><strong>{{ $t('CLIENT_SIDE') }}:</strong></span>
            <table>
              <tr>
                <td class="label">{{ $t('FULL_NAME') }}:</td>
                <td><span>{{ client.firstName }} {{ client.lastName }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('PHONE_NUMBER') }}:</td>
                <td><span>{{ client.primaryPhone }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('BORN_DAY') }}:</td>
                <td><span>{{ moment(client.dateOfBirth, DISPLAY_DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('NATIONAL_ID') }}:</td>
                <td><span>{{ client.nationalId }}</span></td>
              </tr>
              <template v-if="isPurchased && asset.meta.clientName2">
                <tr>
                  <td class="label">{{ $t('FULL_NAME') }} {{ $t('WIFE/HUSBAND') }}:</td>
                  <td><span>{{ asset.meta.clientName2 }}</span></td>
                </tr>
                <tr>
                  <td class="label">{{ $t('NATIONAL_ID') }}:</td>
                  <td><span>{{ asset.meta.nationalId2 }}</span></td>
                </tr>
              </template>
              <tr>
                <td class="label">{{ $t('ADDRESS') }}:</td>
                <td><span>{{ client.address }} {{ client.district }} {{ client.city }}</span></td>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <span><strong>{{ $t('COMPANY_SIDE') }}:</strong></span><br/>
            <span>{{ $t('COMPANY_NAME') }}</span><br/>
            <span>{{ $t('GPKD_DESCRIPTION') }}</span><br/>
            <span>{{ $t('ADDRESS') }}: {{ branchAddress }}</span>
          </b-col>
        </b-row>

        <br/>
        <br/>
        <div><strong>{{ $t('CONFIRM_TWO_SIDE') }}:</strong></div>
        <div class="uppercase"><strong>I. {{ $t('AGREEMENT_ASSET_VALUATION') }}</strong></div>
        <div><strong>{{ $t('ASSET_DESCRIPTION_TSCC') }}:</strong></div>
        <br/>
        <ul>
          <table class="contract">
            <tr>
              <td><li>{{ $t('PLEDGED_ASSET') }}:</li></td>
              <td><span class="margin-left">{{ assetType.description }}</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('ASSET_DESCRIPTION') }}:</li></td>
              <td><div class="margin-left">{{ description }}</div></td>
            </tr>
            <tr>
              <td><li>{{ $t('PART_ACCESSORY') }}:</li></td>
              <td><span class="margin-left">{{ asset.meta.accessory }}</span></td>
            </tr>
            <tr v-if="isPurchased">
              <td><li>{{ $t('REALESTATE_CONDITION') }}:</li></td>
              <td><span class="margin-left">{{ $t('REALESTATE_CONDITION_VALUE') }}</span></td>
            </tr>
            <tr v-else>
              <td><li>{{ $t('NUMBERS') }}:</li></td>
              <td><span class="margin-left">01</span></td>
            </tr>
          </table>
        </ul>
        <div><strong>2. {{ $t('PLEGED_CONDITION') }}:</strong></div>
        <ul>
          <table class="contract">
            <tr>
              <td><li>{{ $t('APPROVED_AMOUNT') }}:</li></td>
              <td><span class="margin-left">{{ addCommas(Math.round(contract.approvedAmount * MILLION)) }} VNĐ</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('DUE_DATE') }}:</li></td>
              <td><span class="margin-left">{{ moment(contract.dueDate, DISPLAY_DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('INTEREST_IN_PERIOD') }}:</li></td>
              <td><span class="margin-left">1.5 %</span></td>
            </tr>
            <tr>
              <td><li>{{ $t('SERVICE_FEE') }}:</li></td>
              <td><span class="margin-left">{{ contract.specialInterestValue - 1.5 }} %</span></td>
            </tr>
            <tr v-if="contract.interestDiscountAmount > 0 && product.prepaid">
              <td>
                <li>{{ $t('PROMOTION') }}:</li>
              </td>
              <td>
                <strong class="margin-left">{{ addCommas(Math.round(contract.interestDiscountAmount * MILLION)) }} VNĐ</strong>
              </td>
            </tr>
          </table>
        </ul>
        <span>
          {{ $t('ICADO_WILL_DISBURSE_FOR_CLIENT') }} <strong>{{ addCommas(Math.round(receivedAmount * MILLION)) }} VNĐ</strong> {{ interestTypeContent1 }} <strong>{{ addCommas(Math.round(contract.interestAmount * MILLION)) }} VNĐ</strong>{{ interestTypeContent2 }}
          <strong>{{ $t('I_CONFIRM_THAT') }}:</strong><i>{{ $t('CONFIRM_TERM') }}.</i>
        </span>
        <br/>
        <br/>
        <b-row class="sign">
          <b-col cols="6">
            <center>
              <span>({{ $t('ICADO_REPRESENT') }})</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
          <b-col cols="6">
            <center>
              <span>{{ $t('CLIENT') }}</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
        </b-row>

        <div class="working-hours">{{ $t('WORKING_HOURS') }}</div>
      </page>

      <page class="terms">
        <div class="uppercase"><strong>II. {{ $t('PLEDGED_TERM') }}</strong></div>
        <span>{{ $t('PLEASE_READ_TERM') }}:</span>
        <br/>
        <br/>

        <div><strong>1. {{ $t('PLEGED_CONDITION') }}:</strong></div>
        <ul>
          <li>{{ $t('CONTRACT_WILL_END_IN') }} {{ product.repayEvery }} {{ $t('DAY') }}. {{ $t('ENDING') }} {{ product.repayEvery }} {{ $t('DAY') }}, {{ $t('CLIENT_CAN_REDEEM_OR_RENEW') }}</li>
          <li>{{ $t('TEMP_1') }}.</li>
          <li>{{ $t('TEMP_2') }}.</li>
          <li>{{ $t('TEMP_3') }}:</li>
          <ul style="list-style-type: square;">
            <li>{{ $t('TEMP_3_1') }}.</li>
            <li>{{ $t('TEMP_3_2') }}.</li>
          </ul>
          <li>{{ $t('TEMP_4') }}:</li>
          <br/>
          <center>
            <table class="bank">
              <tr>
                <td colspan="2">{{ $t('VIETCOMBANK_NAME') }}</td>
              </tr>
              <tr>
                <td>{{ $t('ACCOUNT') }}:</td>
                <td>{{ $t('COMPANY_NAME') }}</td>
              </tr>
              <tr>
                <td>{{ $t('ACCOUNT_NUMBER') }}:</td>
                <td>{{ $t('ICADO_BANK_NUMBER') }}</td>
              </tr>
              <tr>
                <td colspan="2">{{ $t('CONTENT_BANK') }}</td>
              </tr>
            </table>
          </center>
          <br/>
          <li>{{ $t('TEMP_5') }}.</li>
        </ul>

        <div><strong>2. {{ $t('INTEREST_AMOUNT_TERM') }}</strong></div>
        <ul>
          <li>{{ $t('INTEREST_AMOUNT_TERM_1') }}.</li>
          <li>{{ $t('INTEREST_AMOUNT_TERM_2') }}.</li>
        </ul>

        <div><strong>3. {{ $t('ASSET_LIQUIDATION') }}</strong></div>
        <ul>
          <li>{{ $t('LIQUIDATION_TERM_1') }}.</li>
          <li>{{ $t('LIQUIDATION_TERM_2') }}.</li>
        </ul>

        <div><strong>4. {{ $t('ASSET_ORIGIN_COMMITMENT') }}</strong></div>
        <ul>
          <li>{{ $t('ASSET_ORIGIN_COMMITMENT_1') }}.</li>
          <li>{{ $t('ASSET_ORIGIN_COMMITMENT_2') }}.</li>
        </ul>

        <div><strong>5. {{ $t('CONTRACT_REDEEM_REGULATION') }}</strong></div>
        <ul>
          <li>{{ $t('CONTRACT_REDEEM_REGULATION_1') }}.</li>
          <li>{{ $t('CONTRACT_REDEEM_REGULATION_2') }}.</li>
          <li>{{ $t('CONTRACT_REDEEM_REGULATION_3') }}.</li>
        </ul>
        <div> <strong>6. {{ $t('ANOTHER_REGULATION') }}</strong></div>
        <ul>
          <li>{{ $t('ANOTHER_REGULATION_1') }}.</li>
          <li>{{ $t('ANOTHER_REGULATION_2') }}.</li>
          <li>{{ $t('ANOTHER_REGULATION_3') }}.</li>
          <li v-if="isPurchased">{{ $t('ANOTHER_REGULATION_4') }}.</li>
        </ul>

        <div class="working-hours">{{ $t('WORKING_HOURS') }}</div>
      </page>

      <page v-if="isAuthorized" class="authorization">
        <div class="nation">{{ $t('NATION') }}</div>
        <div class="motto">{{ $t('MOTTO') }}</div>
        <br/>
        <div class="hr"/>
        <div class="header">
          <div class="logo-holder">
            <logo-inversed-circle class="icon"/>
            <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
          </div>
          <div class="title-info">
            <span class="bill">{{ $t('AUTHORIZATION_CONTRACT') }}</span><br/>
            <span class="bill">{{ $t('BIKE/CAR') }}</span>
          </div>
        </div>
        <br/>
        <br/>
        <br/>
        <span>{{ $t('DATE') }} {{ moment(contract.maturesDate, DISPLAY_DATE_FORMAT).format('DD-M-YYYY') }}, {{ $t('BEGIN_PARAM') }}:</span>
        <br/>
        <br/>
        <b-row>
          <b-col cols="6">
            <span><strong>{{ $t('AUTHORIZED_SIDE_1') }}:</strong></span>
            <table>
              <tr>
                <td class="label">{{ $t('FULL_NAME') }}:</td>
                <td><span>{{ client.firstName }} {{ client.lastName }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('PHONE_NUMBER') }}:</td>
                <td><span>{{ client.primaryPhone }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('BORN_DAY') }}:</td>
                <td><span>{{ moment(client.dateOfBirth, DISPLAY_DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('NATIONAL_ID') }}:</td>
                <td><span>{{ client.nationalId }}</span></td>
              </tr>
              <tr>
                <td class="label">{{ $t('ADDRESS') }}:</td>
                <td><span>{{ client.address }} {{ client.district }} {{ client.city }}</span></td>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <span><strong>{{ $t('BE_AUTHORIZED_SIDE_1') }}:</strong></span><br/>
            <span>{{ $t('COMPANY_NAME') }}</span><br/>
            <span>{{ $t('GPKD_DESCRIPTION') }}</span><br/>
            <span>{{ $t('ADDRESS') }}: {{ branchAddress }}</span>
          </b-col>
        </b-row>
        <br/>
        <br/>
        <div class="uppercase"><strong>I. {{ $t('AGREEMENT_ASSET_VALUATION') }}</strong></div>
        <span>{{ $t('AUTHORIZED_CONTENT_1') }}: {{ branch }} - {{ newContractMifosId }} {{ $t('AUTHORIZED_CONTENT_2') }}: {{ branch }} - {{ newContractMifosId }}. {{ $t('AUTHORIZED_CONTENT_3') }}:</span>
        <table class="authorized">
          <tr>
            <td><strong>{{ $t('VEHICLE_ID') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.vehicleId }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('CHASSIS_NUMBER') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.chassisNumber }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('LABEL') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.label }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('VEHICLE_TYPE') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.vehicleType }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('PAINTING_COLOR') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.paintingColor }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('LICENSE_PLATE') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.licensePlate }}</strong></td>
          </tr>
        </table>
        <br/>
        <div class="uppercase"><strong>II. {{ $t('COMMITMENT') }}</strong></div>
        <span>{{ $t('COMMITMENT_CONTENT') }}</span>
        <br/>
        <b-row class="sign">
          <b-col cols="6">
            <center>
              <span>{{ $t('AUTHORIZED_SIDE_2') }}</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
          <b-col cols="6">
            <center>
              <span>{{ $t('BE_AUTHORIZED_SIDE_2') }}</span><br>
              ({{ $t('SIGN_AND_WRITE_FULL_NAME') }})
            </center>
          </b-col>
        </b-row>
      </page>
    </print>

    <div id="note" class="border">
      <center>{{ $t('PLEASE_CHECK_MONEY') }} {{ $t('AND') }} {{ $t('PRINT_BILL') }}</center>
      <div class="buttons d-flex justify-content-center">
        <primary-button v-if="closed" @click="cancel" class="button primary-button" white rounded-corner :text="$t('CANCEL')" />
        <primary-button v-else @click="back" class="button primary-button" white rounded-corner :text="$t('BACK')" />
        <icon-button @click="print" class="button" independence :icon="faPrint" :size="40"/>
        <primary-button :disabled="!closed" @click="approve" class="button primary-button" rounded-corner :text="$t('APPROVE')" />
      </div>
    </div>
    <cancel-dialog v-model="on" @saved="canceled" :contractId="contract.id" :contractMifosId="Number.isInteger(newContractMifosId) ? newContractMifosId : -1" :orderId="order.id"/>
  </div>
</template>

<script>
import LogoInversedCircle from '@/components/LogoInversedCircle';
import PrimaryButton from '@/components/PrimaryButton';
import IconButton from '@/components/IconButton';
import Print from '@/components/Print';
import Page from '@/components/Page';
import CancelDialog from '@/components/CancelContractDialog';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { addCommas } from '@/helpers';
import { computed, ref } from '@vue/composition-api';
import { ERROR_CODES, DISPLAY_DATE_FORMAT, DATE_FORMAT, MILLION, ORDER_STEP, ORDER_STAGE, ORDER_STATUS, CONTRACT_STATUSES as STATUSES } from '@/consts';
import logKeys from '@/consts/logKeys';

import loanServices from '@/services/loans';
import clientServices from '@/services/client';
import OrderManagementService from '@/views/Order/OrderManagementService';
import logService from '@/services/log';

import moment from 'moment';

const { useState, useActions } = createNamespacedHelpers('contractNew');
const { useState: useAppState } = createNamespacedHelpers('app');
const { useState: useUserState } = createNamespacedHelpers('user');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');

export default {
  name: 'PrintStep',
  components: {
    LogoInversedCircle,
    PrimaryButton,
    IconButton,
    Print,
    Page,
    CancelDialog,
  },
  setup(props, { root, emit, refs }) {
    const { order, asset, client, contract, products, promotion } = useState(['order', 'asset', 'client', 'contract', 'products', 'promotion']);
    const { assetTypes, branches } = useAppState(['assetTypes', 'branches']);
    const { branch } = useUserState(['branch']);
    const { setClient, setContract } = useActions(['setClient', 'setContract']);
    const { info, error } = useFlashActions(['info', 'error']);
    const creatingContract = ref(false);

    const newContractMifosId = ref('XXXX');

    const assetType = assetTypes.value.find((item) => item.description === order.value.assetType);

    const branchAddress = computed(() => branches.value.find((item) => item.name === branch.value).address);

    const closed = ref(false);

    const product = computed(() => products.value[contract.value.product]);

    const isPurchased = assetType.name === 'Realestate';
    const isAuthorized = ['Car', 'Bike', 'Truck'].includes(assetType.name);

    const description = computed(() => {
      let value = asset.value.description;

      if (isAuthorized) {
        value += `|Nhãn hiệu:${asset.value.meta.label}-Dòng xe:${asset.value.meta.vehicleType}-Số khung:${asset.value.meta.chassisNumber}-Màu sơn:${asset.value.meta.paintingColor}-Số máy:${asset.value.meta.vehicleId}-Biển số đăng ký:${asset.value.meta.licensePlate}`;
      }
      return value;
    });

    const receivedAmount = computed(() => {
      if (product.value.prepaid) {
        const value = contract.value.principalAmount * MILLION + contract.value.interestDiscountAmount * MILLION;
        return Math.round(value / 1000) / 1000;
      }
      return contract.value.approvedAmount;
    });

    const interestTypeContent1 = computed(() => {
      if (product.value.prepaid) {
        return root.$t('PREPAID_CONTENT');
      }
      return root.$t('POSTPAID_CONTENT');
    });

    const interestTypeContent2 = computed(() => {
      if (product.value.prepaid) {
        return '.';
      }
      return ` ${root.$t('POSTPAID_CONTENT_END')}.`;
    });

    const back = () => { emit('back'); };

    const next = () => { emit('next'); };

    const callClient = async () => {
      const data = {
        firstName: client.value.firstName,
        lastName: client.value.lastName,
        primaryPhone: client.value.primaryPhone,
        alternativePhone: client.value.alternativePhone,
        address: client.value.address,
        district: client.value.district,
        city: client.value.city,
        dateOfBirth: moment(client.value.dateOfBirth, DISPLAY_DATE_FORMAT).format(DATE_FORMAT),
        gender: client.value.gender,
      };

      if (client.value.new) {
        data.submittedOnDate = moment(contract.value.maturesDate, DISPLAY_DATE_FORMAT).format(DATE_FORMAT);
        data.nationalId = client.value.nationalId;

        const result = await clientServices.createClient(data);
        setClient({
          new: false,
          id: result.id,
          mifosId: result.mifosId,
        });
      } else {
        await clientServices.updateClient(client.value.id, data);
      }
    };

    const updateAsset = async () => {
      const data = {
        description: asset.value.description,
        asset: assetType.id,
        meta: {
          accessory: asset.value.meta.accessory,
        },
      };

      if (isPurchased) {
        data.meta.clientName2 = asset.value.meta.clientName2;
        data.meta.nationalId2 = asset.value.meta.nationalId2;
      }

      if (isAuthorized) {
        data.meta.label = asset.value.meta.label;
        data.meta.vehicleType = asset.value.meta.vehicleType;
        data.meta.chassisNumber = asset.value.meta.chassisNumber;
        data.meta.paintingColor = asset.value.meta.paintingColor;
        data.meta.vehicleId = asset.value.meta.vehicleId;
        data.meta.licensePlate = asset.value.meta.licensePlate;
      }

      await OrderManagementService.updateAssetOrder(asset.value.id, data);
    };

    const createContract = async () => {
      const data = {
        client: client.value.id,
        requiredAmount: Math.round(order.value.requiredAmount * MILLION),
        proposedAmount: Math.round(order.value.proposedAmount * MILLION),
        approvedAmount: Math.round(contract.value.approvedAmount * MILLION),
        warehousingFee: Math.round(contract.value.warehousingFee * MILLION),
        product: product.value.id,
        specialInterestValue: contract.value.specialInterestValue,
        order: order.value.id,
        maturesDate: moment(contract.value.maturesDate, DISPLAY_DATE_FORMAT).format(DATE_FORMAT),
        validator: contract.value.validator,
      };

      const { item } = await loanServices.createContract(data);

      setContract({ id: item.id });

      newContractMifosId.value = item.mifosId;
    };

    const approve = async () => {
      const payload = {
        stage: ORDER_STAGE.ACTIVE_CONTRACT.val,
        step: ORDER_STEP.CONTRACT,
        status: ORDER_STATUS.SUCCESS,
      };
      await Promise.all([
        loanServices.setContractStatus(contract.value.id, STATUSES.ACTIVE),
        OrderManagementService.updateStage(order.value.id, payload)
      ]);

      const data = {
        contractMifosId: contract.value.mifosId,
        assetType: assetType.name,
        approvedAmount: contract.value.approvedAmount,
        product: product.value.productName,
        specialInterestValue: contract.value.specialInterestValue,
      };
      logService.activityLog(logKeys.CONTRACT_APPROVED, data);
      emit('next');
    };

    const on = ref(false);
    const cancel = () => { on.value = !on.value; };
    const canceled = () => {
      info(root.$t('CANCELED_SUCCESSFULLY'));
      root.$router.push({ name: 'orders' });
    };

    const print = async () => {
      if (creatingContract.value) return;
      creatingContract.value = true;

      try {
        if (!closed.value) {
          await Promise.all([callClient(), updateAsset()]);
          await createContract();
          closed.value = true;
          info(root.$t('NEW_SUCCESSFULLY'));
        }
        creatingContract.value = false;
        refs.print.print();
      } catch (err) {
        creatingContract.value = false;

        const { code, message } = err;
        if (code === ERROR_CODES.ANOTHER_CLIENT_USED_THAT_INFO) {
          error(root.$t('ANOTHER_CLIENT_USED_THAT_INFO'));
        } else {
          error(message);
        }
      }
    };

    return {
      order,
      asset,
      assetType,
      branch,
      client,
      contract,
      product,
      description,
      newContractMifosId,
      promotion,
      receivedAmount,
      isPurchased,
      isAuthorized,
      branchAddress,
      closed,
      back,
      next,
      print,
      approve,
      on,
      cancel,
      canceled,
      faPrint,
      DISPLAY_DATE_FORMAT,
      DATE_FORMAT,
      MILLION,
      interestTypeContent1,
      interestTypeContent2,
      addCommas,
      moment,
    };
  },
};
</script>


<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#print-step {
  .terms {
    font-size: 12.5px;
    padding: 7mm 10mm 7mm 10mm;
  }

  .authorization {
    font-size: 14px;
    padding: 5mm 10mm 5mm 10mm;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .hr {
    border: 1px solid $iron;
    width: 320px;
    margin: 0px auto;
  }

  .nation {
    size: 13px;
    text-align: center;
  }

  .motto {
    size: 11px;
    line-height: 18px;
    text-align: center;
  }

  .header {
    margin-top: 30px;
    position: relative;

    .logo-holder {
      position: absolute;
      top: 5px;
      left: 0;

      .left {
        padding-left: 26px;
        padding-top: 7px;
      }

      .icon {
        color: $alizarinCrimson;
        height: 80px;
        width: 80px;
      }

      .camdo {
        font-size: 15px;
        color: $carmine;
        font-family: 'Source Sans Pro', Tahoma, Arial;
      }

      .nhanh {
        font-size: 15px;
        color: $alizarinCrimson;
      }
    }

    .title-info {
      text-align: center;
      width: 100%;
    }

    .bill {
      text-transform: uppercase;
      font-weight: bolder;
      font-size: 24px;
    }

    .info {
      font-size: 13px;
    }
  }

  ul {
    list-style-type: circle;
  }

  table {
    width: 100%;
    border-spacing: 0;

    &.authorized {
      margin-top: 35px;
      tr {
        td {
          &:first-child {
            width: 115px;
          }
        }
      }
    }

    &.contract {
      tr {
        td {
          &:first-child {
            width: 120px;
          }
        }
      }
    }

    &.bank {
      border: 1px solid $black;
      border-collapse: collapse;
      width: 478px;

      tr {
        td {
          border: 1px solid $black;
          border-collapse: collapse;
          padding: 3px;
        }
      }
    }

    .margin-left {
      margin-left: 50px;
    }

    td {
      &.label {
        width: 120px;
        vertical-align: top;
      }
    }
  }

  .sign {
    margin-top: 20px;
  }

  .divider {
    height: 0;
    border-bottom: 1px dashed $alto;
    width: calc(100% + 20mm);
    margin-left: -10mm;
    margin-top: 80px;
    margin-bottom: 20px;
  }

  #note {
    background-color: $white;
    font-size: 20px;
    padding: 30px;
    position: fixed;
    top: 200px;
    right: 15px;
    width: 350px;
    border-radius: 4px;

    @media (max-width: 1600px) {
      opacity: 0.5;
      transition: all .2s ease-in-out;

      &:hover {
        opacity: 1;
      }
    }

    center {
      font-weight: bolder;
      text-transform: uppercase;
    }

    .buttons {
      margin-top: 28px;

      .button {
        margin: 0px 4px;
        box-shadow: 0px 3px 6px $silver;
      }

      .primary-button {
        padding: 0px 20px;

        /deep/ span {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
